<template>
  <f7-page
    class="bg-gray-100"
  >
    <div class="mt-4 mx-10">
      <div class="text-4xl font-bold">
        Estadisticas vacunación
      </div>
      <div
        v-if="instancesInfo[instanceID].tags"
        class="mb-4 shadow rounded-md p-2 mt-4 bg-white"
      >
        <div>
          Filtra por etiquetas
        </div>
        <tag-manager
          :disabled="false"
          :success="false"
          :selectableTags="instancesInfo[instanceID].tags"
          :currentTags="currentTags"
          :rules="{ regex: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\-' ]*$/ }"
          @tag:add="addTag"
          @tag:remove="removeTag"
          @state:search="isSearching = $event"
        />
      </div>
      <div class="text-lg p-4 border border-gray-300 rounded-lg shadow-sm bg-white">
        <div class="flex justify-between mb-4">
          <div class="text-xl font-bold">
            Histórico dosis
          </div>
        </div>
        <div style="height:400px;">
          <v-chart
            class="chart"
            autoresize
            :option="option"
          />
        </div>
      </div>
      <div class="text-lg p-4 border border-gray-300 rounded-lg shadow-sm bg-white mt-4">
        <div class="flex justify-between mb-4">
          <div class="text-xl font-bold">
            Respuestas vacunación
          </div>
        </div>
        <div style="height:600px;">
          <v-chart
            class="chart"
            autoresize
            :option="sunBurstOption"
          />
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import tagManager from '../components/tagManager'
import moment from 'moment-timezone'
import { mapState, mapGetters } from 'vuex'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart, SunburstChart } from 'echarts/charts'

import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent
} from 'echarts/components'
import VChart, { THEME_KEY, LOADING_OPTIONS_KEY } from 'vue-echarts'

use([
  CanvasRenderer,
  LineChart,
  SunburstChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  ToolboxComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent
])

export default {
  components: {
    tagManager,
    VChart,
  },
  provide: {
    [THEME_KEY]: 'light',
    [LOADING_OPTIONS_KEY]: {
      text: 'cargando...',
      showSpinner: false,
    },
  },
  data () {
    return {
      startDate: moment().tz('America/Bogota'),
      endDate: moment().tz('America/Bogota'),
      option: {},
      datacollection: null,
      currentTags: {},
      loadedData: false,
      sunBurstOption: {},
    }
  },
  computed: {
    totalGuest () {
      if (!this.persons) return 0
      return this.persons.filter(person => person.guest).length // TODO: do this from binding on vuex
    },
    totalInactive () {
      if (!this.persons) return 0
      return this.persons.filter(person => person.active === false).length // TODO: do this from binding on vuex
    },
    activePopulation () {
      if (!this.persons) return 0
      return this.persons.length - this.totalGuest - this.totalInactive
    },
    filteredPersons () {
      if (!this.persons) return []
      const currentTags = Object.keys(this.currentTags)
      return this.persons.filter(person => {
        if (currentTags.length === 0) return true
        if (typeof person.tagIDs === 'undefined') return false
        return currentTags.some(tag => Object.keys(person.tagIDs).includes(tag))
      })
    },
    ...mapState({
      instanceID: state => state.admin.instanceID,
      persons: state => state.admin.persons,
      instancesInfo: state => state.auth.instancesInfo,
    }),
    ...mapGetters({
      tags: 'admin/tags',
    }),
  },
  watch: {
    filteredPersons (val) {
      if (this.persons.length === 0) this.loadedData = false
      if (!this.loadedData) {
        this.processData()
      }
      if (val.length === 0) this.processData()
    },
    currentTags (val) {
      this.processData()
    },
  },
  mounted () {
    // TODO: this should be done in a worker
    this.processData()
  },
  methods: {
    processData () {
      const accumulators = {}
      const answerStatistics = []
      const obj = {
        Aplicadas: 0,
        'No, por decisión propia': 0,
        'No, por recomendación médica': 0,
        'Aún no me la debo aplicar': 0,
      }
      let oldestTime = (new Date()).getTime()
      const today = (new Date()).getTime()
      const monthAgo = today - 30 * 24 * 60 * 60 * 1000
      for (const person of this.filteredPersons) {
        if (typeof person.vaccinationData !== 'undefined') {
          for (const [index, answer] of person.vaccinationData.answers.entries()) {
            if (answer.vaccinated && !isNaN(new Date(answer.date).getTime())) {
              if (answerStatistics[index] === undefined) {
                answerStatistics[index] = { ...obj, Aplicadas: 1 }
              } else {
                answerStatistics[index].Aplicadas += 1
              }
              const time = (new Date(answer.date)).getTime()
              if (time < oldestTime) oldestTime = time
              if (typeof accumulators[index] === 'undefined') {
                accumulators[index] = { [time]: 1 }
              } else {
                if (typeof accumulators[index][time] === 'undefined') {
                  accumulators[index][time] = 1
                } else {
                  accumulators[index][time] += 1
                }
              }
            } else {
              if (answerStatistics[index] === undefined) {
                answerStatistics[index] = { ...obj, [answer.reason]: 1 }
              } else {
                answerStatistics[index][answer.reason] += 1
              }
            }
          }
        }
      }
      this.sunBurstOption = {
        tooltip: {
          trigger: 'item',
          formatter: '<b>{b}</b>: {c}',
        },
        series: {
          type: 'sunburst',
          emphasis: {
            focus: 'ancestor',
          },
          data: answerStatistics.map((statistic, index) => {
            return {
              name: ['Primera dosis', 'Segunda dosis', 'Refuerzo'][index],
              itemStyle: {
                color: ['#37A2DA', '#67E0E3', '#FFDB5C'][index],
              },
              children: [
                {
                  name: 'Aplicadas',
                  value: statistic.Aplicadas,
                  itemStyle: {
                    color: '#6C63FF',
                  },
                },
                {
                  name: 'No, por decisión propia',
                  value: statistic['No, por decisión propia'],
                  itemStyle: {
                    color: '#FF7570',
                  },
                },
                {
                  name: 'No, por recomendación médica',
                  value: statistic['No, por recomendación médica'],
                  itemStyle: {
                    color: '#FFC15E',
                  },
                },
                {
                  name: 'Aún no me la debo aplicar',
                  value: statistic['Aún no me la debo aplicar'],
                  itemStyle: {
                    color: '#282A43',
                  },
                }
              ],
            }
          }),
          radius: [0, '95%'],
          label: {
            textBorderColor: '#fff',
            textBorderWidth: 2,
            rotate: '0',
            fontWeight: 'bold',
            formatter: function (param) {
              if (param.data.children) {
                return `${param.data.name || 'Total'}\n${param.data.value}`
              }
              return `${param.data.value}`
            },
          },
          labelLine: {
            show: true,
            length: 10,
          },
          levels: [
            {},
            {
              r0: '50%',
              r: '83%',
              label: {
                align: 'center',
              },
            },
            {
              r0: '83%',
              r: '85%',
              label: {
                position: 'outside',
                rotate: 'radial',
                padding: 10,
                silent: false,
              },
              itemStyle: {
                borderWidth: 3,
              },
            }
          ],
        },
      }
      const zoomPercent = (monthAgo - oldestTime) * 100 / (today - oldestTime)
      // Sort dates
      for (const index in accumulators) {
        const dates = Object.keys(accumulators[index])
        dates.sort((a, b) => a - b)
        const newAccumulators = {}
        let summary = 0
        for (const date of dates) {
          summary += accumulators[index][date]
          newAccumulators[date] = summary
        }
        newAccumulators[today] = summary
        accumulators[index] = newAccumulators
      }
      if (Object.keys(accumulators).length > 0 || this.loadedData) {
        this.option = {
          legend: {},
          xAxis: {
            type: 'time',
            boundaryGap: false,
          },
          yAxis: {
          },
          tooltip: {
            trigger: 'axis',
          },
          toolbox: {
            feature: {
              saveAsImage: {
                name: 'Poblacion_vacunada',
                title: 'Guardar',
              },
            },
          },
          dataZoom: [
            {
              type: 'inside',
              filterMode: 'none',
              start: Math.round(zoomPercent),
              end: 100,
            },
            {
              start: Math.round(zoomPercent),
              end: 100,
            }
          ],
          series: [
            (accumulators[0] && {
              name: 'Primera dosis',
              type: 'line',
              data: Object.entries(accumulators[0]).map(entry => [new Date(Number(entry[0])), entry[1]]),
            }),
            (accumulators[1] && {
              name: 'Segunda dosis',
              type: 'line',
              data: Object.entries(accumulators[1]).map(entry => [new Date(Number(entry[0])), entry[1]]),
            }),
            (accumulators[2] && {
              name: 'Refuerzo',
              type: 'line',
              data: Object.entries(accumulators[2]).map(entry => [new Date(Number(entry[0])), entry[1]]),
            })
          ],
        }
        this.loadedData = true
      }
    },
    addTag (tagID) {
      if (tagID) {
        if (!this.currentTags[tagID]) {
          this.$set(this.currentTags, tagID, this.tags[tagID])
        }
      }
    },
    removeTag (tagID) {
      this.$delete(this.currentTags, tagID)
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../css/_brand";

</style>
